import styled from 'styled-components'

const StyledLoopingText = styled.div`
  font-size: 20px;
  padding: 20px;
  text-align: center;
`

export default StyledLoopingText